import { z } from 'zod';

/**
 * Reset password form validation schema for the Massager (checkin) portal.
 * Mirrors RA2 Massager\ResetPasswordController rules: min 6, confirmed.
 */
export const massagerResetPasswordFormSchema = z
  .object({
    clinic_number: z.string().trim().min(1, '治療院IDは必須です。'),
    login_id: z.string().trim().min(1, '施術者ログインIDは必須です。'),
    password: z
      .string()
      .superRefine((value, ctx) => {
        const v = value.trim();
        if (!v) {
          ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'パスワードは必須です。' });
          return;
        }
        if (v.length < 6) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'パスワードは6文字以上にしてください。',
          });
        }
      }),
    password_confirmation: z
      .string()
      .superRefine((value, ctx) => {
        const v = value.trim();
        if (!v) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '確認用新しいパスワードは必須です。',
          });
        }
      }),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: 'パスワードは確認用項目と一致していません。',
    path: ['password_confirmation'],
  });

export type MassagerResetPasswordFormData = z.infer<typeof massagerResetPasswordFormSchema>;
